var map = {
	"./assets/bottom-arrow.png": "8f5d",
	"./assets/chart-pointer.svg": "52f6",
	"./assets/checkmark.svg": "e3eb",
	"./assets/click-me.png": "d48a",
	"./assets/click-result.png": "23c3",
	"./assets/colour-star.svg": "b0da",
	"./assets/crossmark.svg": "6f54",
	"./assets/energy-banner.png": "5ef6",
	"./assets/energy.jpg": "48e4",
	"./assets/energy.svg": "24d6",
	"./assets/face-animation": "a5fd",
	"./assets/face-animation.json": "a5fd",
	"./assets/facial-skin-age.svg": "3856",
	"./assets/grey-star.svg": "0e05",
	"./assets/kristian-suhartono.png": "c493",
	"./assets/kyle-wong.png": "a2b1",
	"./assets/left-arrow-icon.svg": "e612",
	"./assets/left-arrow.png": "f11b",
	"./assets/lify.svg": "1c40",
	"./assets/logo.svg": "c3b3",
	"./assets/next.svg": "244b",
	"./assets/nick-chin.png": "bb5b",
	"./assets/panoptic_ai.svg": "2642",
	"./assets/panoptic_ai_vitals.png": "5d25",
	"./assets/placeholder-image.png": "7f4c",
	"./assets/previous.svg": "e8e0",
	"./assets/professor-richard-so.png": "9536",
	"./assets/redo.png": "f369",
	"./assets/report.svg": "6a62",
	"./assets/right-arrow.png": "854b",
	"./assets/sleep-banner.png": "b157",
	"./assets/sleep.jpg": "1127",
	"./assets/sleep.svg": "3055",
	"./assets/sooth-banner.png": "7fdf",
	"./assets/sooth.jpg": "8a43",
	"./assets/sooth.svg": "1ae2",
	"./assets/start-button.png": "30f0",
	"./assets/start-icon.svg": "5a85",
	"./assets/stress.svg": "fa25",
	"./assets/sunset-banner.png": "f98c",
	"./assets/sunset.jpg": "0790",
	"./assets/sunset.svg": "3dfc",
	"./assets/switch-camera.svg": "11c9",
	"./assets/tda-logo.svg": "2874",
	"./assets/tea.svg": "2ad4",
	"./assets/teric-chan.png": "ba1f",
	"./assets/warning.svg": "b962",
	"./assets/watermark.png": "fdc5",
	"./assets/wellness.svg": "c578",
	"./assets/young-banner.png": "7493",
	"./assets/young.jpg": "2d8b",
	"./assets/young.png": "c1ea",
	"./breathing-circle": "29b9",
	"./breathing-circle.vue": "29b9",
	"./camera": "3a8b",
	"./camera.js": "3a8b",
	"./circular-progress": "183e",
	"./circular-progress.vue": "183e",
	"./components/back-button": "2c6f",
	"./components/back-button.vue": "2c6f",
	"./components/background-circle": "e1e0",
	"./components/background-circle.vue": "e1e0",
	"./components/experience-again-button": "8a93",
	"./components/experience-again-button.vue": "8a93",
	"./components/general-wellness-chart": "df41",
	"./components/general-wellness-chart.vue": "df41",
	"./components/scan-completed-button": "0f7d",
	"./components/scan-completed-button.vue": "0f7d",
	"./components/view-more-button": "9c7b",
	"./components/view-more-button.vue": "9c7b",
	"./components/view-research-content-button": "2892",
	"./components/view-research-content-button.vue": "2892",
	"./components/vital-sign-button-js": "b278",
	"./components/vital-sign-button-js.vue": "b278",
	"./components/vital-sign-chart": "8288",
	"./components/vital-sign-chart.vue": "8288",
	"./components/vitals-box": "354b",
	"./components/vitals-box.vue": "354b",
	"./condition-checking": "9015",
	"./condition-checking.vue": "9015",
	"./condition-icon": "9d20",
	"./condition-icon.vue": "9d20",
	"./conditions-hud": "1921",
	"./conditions-hud.vue": "1921",
	"./face-detection-view": "a5cf",
	"./face-detection-view.vue": "a5cf",
	"./face-landmarks-detection": "c54d",
	"./face-landmarks-detection.js": "c54d",
	"./face-mesh-view": "6364",
	"./face-mesh-view.css": "8d30",
	"./face-mesh-view.vue": "6364",
	"./full-article": "dee4",
	"./full-article.vue": "dee4",
	"./home-page": "0537",
	"./home-page.vue": "0537",
	"./plans": "6b71",
	"./plans.js": "6b71",
	"./research-content": "f41f",
	"./research-content.vue": "f41f",
	"./result": "175e",
	"./result.vue": "175e",
	"./user-profile-input": "0f2d",
	"./user-profile-input.vue": "0f2d",
	"./vital-sign-button": "1796",
	"./vital-sign-button.vue": "1796"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96ad";